module.exports = __webpack_public_path__ + "static/img/erweima_pre2.c386204.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/erweima/erweima_pre2.jpg
// module id = CndZ
// module chunks = 124